<template>
  <div class="Shenqing">
    <div class="container">
      <h2>大学申请服务</h2>
      <p>通过使用助学申请服务，您可以一次进行多个申请。助学顾问将帮助您选择最佳课程，助学学生服务团队将协助您准备和提交所需文件。</p>
      <p>一旦中国大学收到您的申请，助学将定期向您报告您申请的处理阶段。助学负责从大学获取入学信息，并在线通知学生入学决定。助学受命从各大学接收您的入学包裹，并将其发送给您。</p>
      <div class="imgbox">
        <img src="@/assets/shenqing3.png"
             alt="">
      </div>
      <div class="tips">提示</div>
      <p class="tips_p">一般来说，您只需支付最低的助学服务费50美元。以下9所大学收费150美元：</p>
      <div>
        <van-row gutter="10">
          <van-col span="8">
            <div class="ttis">
              <div class="imgbox">
                <img src="@/assets/xiaohui1.jpg"
                     alt="">
              </div>
              <div class="tt">北京大学</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="ttis">
              <div class="imgbox">
                <img src="@/assets/xiaohui2.jpg"
                     alt="">
              </div>
              <div class="tt">复旦大学</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="ttis">
              <div class="imgbox">
                <img src="@/assets/xiaohui3.jpg"
                     alt="">
              </div>
              <div class="tt">清华大学</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="ttis">
              <div class="imgbox">
                <img src="@/assets/xiaohui4.jpg"
                     alt="">
              </div>
              <div class="tt">同济大学</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="ttis">
              <div class="imgbox">
                <img src="@/assets/xiaohui5.jpg"
                     alt="">
              </div>
              <div class="tt">中山大学</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="ttis">
              <div class="imgbox">
                <img src="@/assets/xiaohui6.jpg"
                     alt="">
              </div>
              <div class="tt">暨南大学</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="ttis">
              <div class="imgbox">
                <img src="@/assets/xiaohui7.jpg"
                     alt="">
              </div>
              <div class="tt">中国人民大学</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="ttis">
              <div class="imgbox">
                <img src="@/assets/xiaohui8.jpg"
                     alt="">
              </div>
              <div class="tt">南京航空航天大学</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="ttis">
              <div class="imgbox">
                <img src="@/assets/xiaohui9.jpg"
                     alt="">
              </div>
              <div class="tt">中央民族大学</div>
            </div>
          </van-col>
        </van-row>
      </div>
      <div class="tit1">申请程序</div>
      <div class="imgbox">
        <img src="@/assets/shenqing2.jpg"
             alt="">
      </div>
      <div class="buzhu">
        <van-steps direction="vertical"
                   :active="10">
          <van-step>
            <h3>STEP 1</h3>
            <div class="lis">选择大学和课程</div>
          </van-step>
          <van-step>
            <h3>STEP 2</h3>
            <div class="lis">完成在线申请</div>
          </van-step>
          <van-step>
            <h3>STEP 3</h3>
            <div class="lis">支付由学校直接收取的申请费</div>
          </van-step>
          <van-step>
            <h3>STEP 4</h3>
            <div class="lis">跟踪申请程序状态并获得结果</div>
          </van-step>
        </van-steps>
      </div>
      <div class="shenqingTit">申请后，您可能需要知道</div>
      <p style="text-indent:1em;">申请成功。我该怎么办？</p>
      <p style="text-indent:1em;">答：回答文本</p>
      <p style="text-indent:1em;">申请被拒绝。我该怎么办？</p>
      <p style="text-indent:1em;">答：回答文本</p>
      <div class="shenqingTit">服务费</div>
      <p>助学收取的最低服务费为50美元。</p>
      <p>您需要支付申请费，申请费由学校直接收取，助学有权代为收取。</p>
      <div class="shenqingTit">大学申请服务标准</div>
      <p>在提交给助学的24小时内处理申请</p>
      <p>收到学校的录取决定后，立即在线发布录取决定</p>
      <p>在一个工作日内回复电子邮件</p>
      <p>邮寄地址确认后，通过DHL（首次免费）寄送入场包裹</p>
      <div class="shenqingTit">常见问题</div>
    </div>
    <van-tabs type="card">
      <van-tab title="选课">
        <div class="cont-card">
          <van-collapse v-model="activeNames">
            <van-collapse-item :title="item.title"
                               :name="index"
                               v-for="(item,index) in faq"
                               :key="index">
              <div v-html="item.content"
                   class="faq-detail"></div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-tab>
      <van-tab title="网上申请">
        <div class="cont-card">
          <van-collapse v-model="activeNames">
            <van-collapse-item :title="item.title"
                               :name="index"
                               v-for="(item,index) in faq2"
                               :key="index">
              <div v-html="item.content"
                   class="faq-detail"></div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-tab>
      <van-tab title="支付费用">
        <div class="cont-card">
          <van-collapse v-model="activeNames">
            <van-collapse-item :title="item.title"
                               :name="index"
                               v-for="(item,index) in faq3"
                               :key="index">
              <div v-html="item.content"
                   class="faq-detail"></div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-tab>
      <van-tab title="取得成果">
        <div class="cont-card">
          <van-collapse v-model="activeNames">
            <van-collapse-item :title="item.title"
                               :name="index"
                               v-for="(item,index) in faq4"
                               :key="index">
              <div v-html="item.content"
                   class="faq-detail"></div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-tab>
    </van-tabs>
    <div class="botline">
      没有更多了
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axiosApi from "../api/api.js";

export default {
  name: 'Shenqing',
  components: {
  },
  data () {
    return {
      activeNames: ['0'],
      faq: [],
      faq2: [],
      faq3: [],
      faq4: [],
    }
  },
  mounted () {
    axiosApi(
      'news/25', {}, 'get'
    ).then((res) => {
      this.faq = res.data.data
    })
    axiosApi(
      'news/26', {}, 'get'
    ).then((res) => {
      this.faq2 = res.data.data
    })
    axiosApi(
      'news/27', {}, 'get'
    ).then((res) => {
      this.faq3 = res.data.data
    })
    axiosApi(
      'news/29', {}, 'get'
    ).then((res) => {
      this.faq4 = res.data.data
    })
  }
}
</script>

<style lang="scss" scoped>
.Shenqing {
  height: 100% !important;
  overflow: auto;
}
.container {
  padding-bottom: 0;
  h2 {
    text-align: center;
  }
  font-size: 28px;
  p {
    margin-bottom: 20px;
    text-indent: 2em;
  }
  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}
[class*="van-hairline"]::after {
  border: none;
}
.cont-card {
  padding: 20px 0;
}
.ttis {
  margin-bottom: 20px;
  .imgbox {
    height: 200px;
    img {
      width: 160px;
    }
  }
  .tt {
    text-align: center;
    font-size: 24px;
  }
}
.faq-detail {
  color: #545454;
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
</style>
